import { AnyIfEmpty } from 'react-redux';
import {
    GET_VENDOR_VISIT_FAILURE,
    GET_VENDOR_VISIT_REQUEST,
    GET_VENDOR_VISIT_SUCCESS,
} from '../constants/vendorVisit.constants';
import axios, { AxiosResponse } from 'axios';
import { vendorAppointmentAccessCodeProps } from '../../../components/vendorAppointments/VendorAppointments';

const getVendorVisitRequest = () => {
    return {
        type: GET_VENDOR_VISIT_REQUEST,
    };
};

const getVendorVisitSuccess = (locationByIdData: AnyIfEmpty<object>) => {
    return {
        type: GET_VENDOR_VISIT_SUCCESS,
        payload: locationByIdData,
    };
};

const getVendorVisitFailure = (locationByIdError: string) => {
    return {
        type: GET_VENDOR_VISIT_FAILURE,
        payload: locationByIdError,
    };
};

export const getVendorVisit = (locationId: string | any) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getVendorVisitRequest());
        return await axios
            .get(`/vendor-visit/${locationId}`)
            .then((response: AxiosResponse) => {
                if (response.data.statusCode === 200) {
                    dispatch(getVendorVisitSuccess(response.data));
                } else {
                    dispatch(getVendorVisitFailure(response.data.message));
                }
            })
            .catch((err) => dispatch(getVendorVisitFailure(err?.response?.data?.message)));
    };
};

export const getVendorLocationVisit = (
    vendorAppointment: vendorAppointmentAccessCodeProps,
    onSuccess: (accessCode: string) => void,
    onBMSSuccess: (message: string) => void,
    onFailure: (message: string) => void,
    setLoading: (loading: boolean) => void,
) => {
    return async () => {
        setLoading(true);
        axios
            .get(`/vendor-visit`, {
                params: {
                    latitude: vendorAppointment.latitude,
                    longitude: vendorAppointment.longitude,
                    vendorId: vendorAppointment.vendorId,
                },
            })
            .then(async (response) => {
                if (response?.data?.statusCode === 200) {
                    if (response?.data?.code) {
                        onSuccess(response?.data?.code);
                    }
                    if (response?.data?.locker) {
                        onBMSSuccess(response?.data?.message);
                    }
                } else {
                    onFailure(response?.data?.message);
                }
            })
            .catch((error) => {
                onFailure(error?.response?.data?.message);
            })
            .finally(() => {
                setLoading(false); // Stop loader
            });
    };
};
